import { Player, Group, Database } from '../../types';
import { generateGroupCode } from '../stringUtils';
import { STATIC_CLUBS_SEED_DATA } from '../clubUtils';

export const DB_VERSION = 14;

export const migrateData = (data: any): Database => {
    if (!data.groups) data.groups = [];
    if (!data.dataVersion || data.dataVersion < DB_VERSION) {
        data.groups.forEach((g: Group) => {
            if (!g.clubs) g.clubs = [];
            if (!g.code) g.code = generateGroupCode();

            if (!g.players) g.players = [];
            // Basic sync to ensure fields exist
            g.players.forEach((p: Player) => {
                if (!p.badges) p.badges = [];
                // Initialize Glicko-2 fields if missing
                if (!p.rating) p.rating = 1500;
                if (!p.rd) p.rd = 350;
                if (!p.volatility) p.volatility = 0.06;
                if (!p.ratingHistory) p.ratingHistory = [];
            });

            // AGGRESSIVE CLUB SYNC: Check existing clubs and add data if missing
            STATIC_CLUBS_SEED_DATA.forEach(fc => {
                const existingClub = g.clubs.find((c: any) => c.name === fc.name && c.city === fc.city);
                if (existingClub) {
                    if (!existingClub.phone && fc.phone) existingClub.phone = fc.phone;
                    if (!existingClub.mapsUrl && fc.mapsUrl) existingClub.mapsUrl = fc.mapsUrl;
                    if (!existingClub.department && fc.department) existingClub.department = fc.department;
                }
            });
        });
        data.dataVersion = DB_VERSION;
    }
    return data as Database;
};
